import React, { useRef, useState } from 'react';
import { PlayCircle, PauseCircle } from 'lucide-react';

const AudioPlayer = ({ path }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const handlePlayPause = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  // Fonction appelée automatiquement lorsque le son arrive à sa fin
  const handleEnded = () => {
    setIsPlaying(false);
  };

  return (
    <div>      
      <button
        style={{
            backgroundColor: 'transparent',
            border: 'none',
        }}
        onClick={handlePlayPause}
      >
        {isPlaying ? <PauseCircle /> : <PlayCircle />}
      </button>

      {/* Élément audio avec un écouteur sur la fin (onEnded) */}
      <audio ref={audioRef} src={path} onEnded={handleEnded} />
    </div>
  );
};

export default AudioPlayer;
